
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_MANAGER_CONTRACTORS from "@/apollo/contractors/GetManagerContractors.gql";

  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
  import UIButton from "@/components/button/ui-button.vue";
  import CardPagination from "@/components/card/PaginationNew.vue";
  import AddContractorToManager from "@/components/contractors/AddContractorToManagerNew.vue";

  import PaginationConfig from "@/entities/PaginationConfig";
  import paginationConfig from "@/data/paginationConfig";
  import ContractorCard from "@/components/companyContractors/ContractorCardNew.vue";
  import ContractorRating from "@/components/rating/ContractorRatingNew.vue";
  import { Contractor, Manager_Contractor, User, User_Profile } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";
  import getFullName from "@/helpers/getFullName";
  import RemoveAccessToContractor from "@/components/managers/RemoveAccessToContractorNew.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
import { NO_INFORMATION } from "@/data/placeholders";
  import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";

  @Component({
    components: {
      EmptyListImageContractors,
      CardBodyItem,
      RemoveAccessToContractor,
      ContractorRating,
      ContractorCard,
      LoadingOverlay,
      EmptyListPlaceholder,
      UIButton,
      CardPagination,
      AddContractorToManager,
    },
    apollo: {
      managerContractors: {
        query: GET_MANAGER_CONTRACTORS,
        variables() {
          return this.conditions;
        },
        update(data) {
          this.paginationConfig.total = data.total.aggregate.count;
          this.paginationConfig.loadedCount = data.manager_contractor.length;
          return data.manager_contractor;
        },
      },
    },
  })
  export default class Contractors extends Vue {
    @Prop({ type: String, required: true }) readonly managerId!: string;
    @Prop({ type: String, required: true }) readonly managerFullName!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    

    managerContractors: Manager_Contractor[] = [];
    paginationConfig: PaginationConfig = { ...paginationConfig };

    get conditions(): Object {
      const { page, limit } = this.paginationConfig;
      const nextOffset = page * limit - limit;

      var confirmedConditions = {};

      if(!(this.currentUser.role === "ADMIN")) {
        confirmedConditions = {
          confirmed: {
        _eq: true
      }
        }
      }

      return {
        currentUserId: this.currentUser.id,
        limit: this.paginationConfig.limit,
        offset: nextOffset,
        where: {
          _and: [
            {
              manager_id: {
                _eq: this.managerId,
              },
            },
            {
              approved: {
                _eq: true
              },
            },
            {
              contractor: {
                _and: [
                  {
                    deleted: {
                      _eq: false
                    }
                  },
                  {
                    approved: {
                      _eq: true
                    }
                  },
                  {
                    user: confirmedConditions
                  }
                ]
              }
            }
          ],
        },
      };
    }

    get emptyListTitle(): string {
      return `${this.managerFullName} does not have any resources yet`;
    }

    get isEmpty(): boolean {
      return this.managerContractors.length === 0;
    }

    get isDataLoaded(): boolean {
      return this.managerContractors.length > 0 || !this.loading;
    }

    get loading(): boolean {
      return this.$apollo.queries.managerContractors.loading;
    }
    get isManagerRole(): boolean {
      return this.currentUser.role === "MANAGER";
    }

    getContractorFullName(contractor: Contractor): string {
      const { given_name, family_name } = contractor.user;
      return getFullName(given_name!, family_name!);
    }
getOccupation(contractor): String | null {
 if (
			contractor &&
			contractor.user &&
      contractor.user?.profile?.job_title
			
		) {
      return contractor.user?.profile
				?.job_title;
			
		} else if (
			contractor.user.experiences[0]
				?.job_title
		) {
			return contractor.user?.experiences[0]
				.job_title;
		} else {
			return;
		}
	}


    getLocation(profile: User_Profile): string {
      if (!profile) {
        return NO_INFORMATION;
      }
      const location = [profile.city, profile.country].filter(place => Boolean(place)).join(" ");
      return location || NO_INFORMATION;
    }

    refetchContractors(): void {
      this.$emit("collectionUpdated");
      this.$apollo.queries.managerContractors.refetch();
    }

    message(userId: string): void {
      this.$router.push({
        name: RouteNames.INBOX,
        query: {
          recipientUserId: userId,
        },
      });
    }
  }
